import { render, staticRenderFns } from "./BeVenueReviews.vue?vue&type=template&id=e6e9fbfc&scoped=true"
import script from "./BeVenueReviews.vue?vue&type=script&lang=js"
export * from "./BeVenueReviews.vue?vue&type=script&lang=js"
import style0 from "./BeVenueReviews.vue?vue&type=style&index=0&id=e6e9fbfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e9fbfc",
  null
  
)

export default component.exports